<script setup lang="ts">
import { ref } from 'vue'
import { Button } from '~/components/ui/button'
import {
  Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle,
} from '~/components/ui/card'
import { Input } from '~/components/ui/input'
import { Label } from '~/components/ui/label'

definePageMeta({ layout: 'auth' })

const email = ref('')
const sent = ref(false)
const submitting = ref(false)
const errorMessage = ref('')

async function handleSubmit() {
  errorMessage.value = ''
  submitting.value = true
  try {
    const { $api } = useNuxtApp()
    await $api('/admin/account/send-reset-password-mail', {
      method: 'POST',
      body: { email: email.value },
    })
    sent.value = true
  }
  catch {
    errorMessage.value = '寄送失敗，請確認帳號是否正確或稍後再試'
  }
  finally {
    submitting.value = false
  }
}
</script>

<template>
  <form @submit.prevent="handleSubmit">
    <Card class="w-full max-w-lg">
      <CardHeader class="space-y-1 text-center">
        <CardTitle class="text-2xl font-semibold">忘記密碼</CardTitle>
        <CardDescription>輸入帳號，我們會寄送重設密碼信件</CardDescription>
      </CardHeader>
      <CardContent class="space-y-4">
        <p v-if="sent" class="text-sm text-green-600" role="status">
          重設密碼信件已寄出，請至信箱收信
        </p>
        <template v-else>
          <div class="space-y-2">
            <Label for="email">帳號</Label>
            <Input id="email" v-model="email" type="email" placeholder="請輸入帳號（Email）" required autocomplete="username" />
          </div>
          <p v-if="errorMessage" class="text-sm text-red-600" role="alert">{{ errorMessage }}</p>
        </template>
      </CardContent>
      <CardFooter class="flex-col gap-2">
        <Button v-if="!sent" type="submit" class="w-full" :disabled="submitting">
          {{ submitting ? '寄送中…' : '寄送重設信' }}
        </Button>
        <NuxtLink to="/login" class="text-sm text-indigo-600 hover:underline">返回登入</NuxtLink>
      </CardFooter>
    </Card>
  </form>
</template>
